// extracted by mini-css-extract-plugin
module.exports = {"successTitle":"styles_successTitle__3wXX-","successMessage":"styles_successMessage__rOvrG"};